import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor, EnablePersistence } from './app/store';

import ApplicationLoading from './ApplicationLoading';
// import reportWebVitals from './reportWebVitals';

window.console.log('==========');
window.console.log('iFMS initialization started');
window.console.log('Persistence enabled: ' + EnablePersistence);
window.console.log('==========');
ReactDOM.render(
  EnablePersistence
    ?
    <Provider store={store}>
      <PersistGate loading={<ApplicationLoading />} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
    :
    <Provider store={store}>
      <App />
    </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
